// extracted by mini-css-extract-plugin
module.exports = {"root":"_8b54db","infoCircle":"_be8613","tag":"_f40cfb"};